export const CookieLoad = (key) => {
  if (typeof (key) === 'string') {
    const rawName = key + '=';
    const rawCookies = document.cookie.split(';');

    for (let index = 0; index < rawCookies.length; index++) {
      let rawCookie = rawCookies[index];

      while (rawCookie.charAt(0) === ' ') {
        rawCookie = rawCookie.substring(1);
      }

      if (rawCookie.indexOf(rawName) === 0) {
        return decodeURIComponent(rawCookie.substring(rawName.length, rawCookie.length));
      }
    }
    return '';
  } else {
    throw new TypeError('매개변수가 String 타입이 아닙니다.');
  }
};

export const GoogleTranslateElementInit = (key) => {
  const langList = {
    ko: '한국어',
    en: 'English',
    ja: 'Japan',
    'zh-CN': 'China',
    th: 'Thailand',
    vi: 'Vietnam',
    ru: 'Russia',
    es: 'Spain',
    pt: 'Portugal',
    de: 'Deutschland',
    fr: 'France',
    ar: 'Saudi Arabia',
    id: 'Indonesia'
  };

  setTimeout(function () {
    new window.google.translate.TranslateElement({
      pageLanguage: 'ko',
      layout: 4,
      multilanguagePage: true,
      autoDisplay: false,
      includedLanguages: Object.keys(langList).toString()
    }, 'sbs-gnb-footer-language-self');
  }, 300);
};
